require('../../css/components/SubjectSlat.scss');

'use strict';
